export const pathToEmailValidationPage = "/injuryreporting/ita/email-info-page";
export const pathToLogin="/injuryreporting/ita";
export const pathToOshaHome="/";
export const pathToBaseUrl="https://www.osha.gov";
export const pathToLogout="/saml/logout";
export const pathToCreateAccount="/injuryreporting/ita/create-account";
export const pathToForgotPassword = "/injuryreporting/ita/forgot-password";
export const pathToHelpRequest = '/injuryreporting/ita/help-request-form';
export const pathToHelpRequestConfirm = "/injuryreporting/ita/help-request-form/confirmed";
export const pathToHome="/injuryreporting/ita/home";
export const pathToEstablishmentsDashboardPage="/injuryreporting/ita/establishments";
export const pathToCreateEstablishmentPage="/injuryreporting/ita/establishments/create";
export const pathToBulkTransferPage="/injuryreporting/ita/bulktransfer";
export const pathToInjuryReporting="/injuryreporting";
export const pathToITAUserGuide="https://www.osha.gov/sites/default/files/ita_user_guide.pdf";

export const pathToEditEstablishmentPage="/edit";

export const accountPageBase = "/injuryreporting/ita/account";
export const pathToAccountPage="/profile";
export const pathToAccountEditPage="/profile/edit";
export const pathToApiTokenPage="/api-token";

export const pathToInjurySummaryFormPageAdd = "/add-300a";
export const pathToInjurySummaryFormPageEdit = "/edit-300a";

export const pathToSubmissionPage="/submission";
export const pathToFileUploadForm = "/injuryreporting/ita/file-upload";
export const pathToCaseDataFileUploadForm = "/injuryreporting/ita/case-data-file-upload";
export const pathToLoginWithPasswordReset = '/injuryreporting/ita/password-saved';
export const pathToChangePassword = '/injuryreporting/ita/account/change-password';
export const pathToAccessDenied = 'access-denied';
export const pathToPageNotFound = '/injuryreporting/ita/page-not-found';

export const pathToCaseDataFormPageAdd = "/add-case-data";
export const pathToCaseDataDashboardPage = "/case-data";
export const pathToCaseDataFormPageEdit = "/edit-case-data";
export const pathToDeleteCaseData = "/delete-case-data";



/** WEBPACK FOOTER **
 ** ./src/constants/pathConstants.js
 **/